module.exports = __webpack_public_path__ + "img/minus.861c42cb.svg";